import { Component } from '@angular/core';
import { FormComponentLookup } from '@ptl/forms';
import { MassUploadFormControlComponent } from '../mass-upload-form-control.component';

@FormComponentLookup('mass-upload-grid-control-zip-code')
@Component({
  selector: 'app-mass-upload-zip-code-form-control',
  templateUrl: '../mass-upload-form-control.component.html',
  styleUrl: '../mass-upload-form-control.component.scss',
  standalone: false
})
export class MassUploadZipCodeFormControlComponent extends MassUploadFormControlComponent {

  ngOnInit() {
    super.ngOnInit();

    // Zip code specific initialization
    this.entry.formControlAttributes.validators.push({
      "type": "required",
      "value": true
    });

    // All form controls are initialized at the same time, so this timeout is needed to trigger the value changes observable
    setTimeout(() => {
      this.selfAsFormControl.setValue(this.selfAsFormControl.value);
    }, 1);
  }
}
